/* Meta Conversions API — Lead Capture client-side field helper.
 *
 * Exposes `window.fmGetMetaLeadFields()` which returns the browser-only
 * signals that Meta's CAPI needs for high Event Match Quality on the
 * server-side Lead event:
 *
 *   fbc               Facebook click ID — from `_fbc` cookie set by Pixel,
 *                     or constructed from `?fbclid=` per Meta's spec:
 *                     `fb.1.<unix_ms>.<fbclid>`.
 *   fbp               Facebook browser ID — from `_fbp` cookie set by Pixel.
 *   user_agent        navigator.userAgent at submission time.
 *   event_source_url  Current page URL — what Meta calls `event_source_url`.
 *
 * `client_ip` is intentionally NOT captured here — it cannot be trusted
 * client-side and must be read from the HTTP request headers on the
 * server (postdata.php / the ProofCreate Function App / Power Automate
 * HTTP trigger) and written to `cr174_clientip` from there.
 *
 * These four fields are POSTed into customerData by the lead-creating
 * customizer JS (custom-product-customizer.js, eq-product-script.js,
 * pet-mats-custom-product-customizer.js) and forwarded to Dataverse
 * columns `cr174_fbc / cr174_fbp / cr174_useragent / cr174_eventsourceurl`.
 */
(function () {
  function getCookie(name) {
    try {
      var match = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()\[\]\\\/+^]/g, '\\$&') + '=([^;]*)')
      );
      return match ? decodeURIComponent(match[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function getUrlParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function buildFbc() {
    var cookieFbc = getCookie('_fbc');
    if (cookieFbc) return cookieFbc;
    var fbclid = getUrlParam('fbclid');
    if (!fbclid) return '';
    return 'fb.1.' + Date.now() + '.' + fbclid;
  }

  /* Marketing-consent proxy.
   *
   * Meta Pixel sets `_fbp` on page load. If the consent platform
   * (Consentmo) correctly blocks the Pixel until the visitor accepts
   * marketing cookies, `_fbp` only exists when consent was given —
   * so its presence is a reliable proxy. If `_fbp` is missing the
   * Power Automate Meta CAPI branch will skip the send.
   *
   * IMPORTANT: this proxy assumes the consent platform actually gates
   * the Pixel. If the banner allows Pixel to fire before consent
   * (e.g. pre-ticked categories), `_fbp` will be set for most visitors
   * regardless of actual consent and the proxy becomes meaningless.
   * Fix the banner config before relying on this for compliance. */
  window.fmGetMetaLeadFields = function () {
    var fbpValue = getCookie('_fbp');
    return {
      fbc: buildFbc(),
      fbp: fbpValue,
      user_agent: (typeof navigator !== 'undefined' && navigator.userAgent) || '',
      event_source_url: (typeof window !== 'undefined' && window.location && window.location.href) || '',
      marketing_consent: !!fbpValue
    };
  };
})();
